import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';
import { icons, fontAwesomeDom } from './icons';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    treeShake: true,
    themes: {
      light: {
        primary: '#125CD3',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
      dark: {
        primary: colors.blue.darken2,
        accent: colors.grey.darken3,
        secondary: colors.amber.darken3,
        info: colors.teal.lighten1,
        warning: colors.amber.base,
        error: colors.deepOrange.accent4,
        success: colors.green.accent3,
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: ['faSvg', 'mdiSvg'],
    values: {
      ...icons,
    },
  },
});

fontAwesomeDom.watch();
